// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3VWY3","label":"Completed_label__1_U7J"};